import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { TracerProfile } from '../models/TracerProfile';

export class TracerProfileMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): TracerProfile {
    const ecInfo = this.findAndSortValues(data.ecProfile);
    const rsaInfo = this.findAndSortValues(data.rsaProfile);
    const symmetricInfo = this.findAndSortValues(data.symmetricProfile);
    const certificateInfo = this.findAndSortValues(data.certificateValidityProfile);
    const staleKeyInfo = this.findAndSortValues(data.staleKeyProfile);

    const disabledRulesNumbers = data.disabledRules?.map((rule: any) => rule.ruleNumber);
    const expiringSoon = data.expiringSoon;

    return new TracerProfile(
      this.gqlIdEncoder.decode(data.id),
      data.name,
      data.type,
      data.preset,
      new Set(disabledRulesNumbers),
      ecInfo,
      rsaInfo,
      staleKeyInfo,
      certificateInfo,
      symmetricInfo,
      expiringSoon
    );
  }

  // Returns null if no values were given from the API.
  // If values are found we return them in a sorted array.
  private findAndSortValues(apiData: any) {
    if (!apiData) {
      return null;
    }
    return [apiData.medHighThreshold, apiData.lowMedThreshold, apiData.offLowThreshold].sort((a, b) => a - b);
  }
}
